export default __webpack_public_path__ + "static/media/img5.4beb2786.jpg";